import React from "react";
import { Share2, Image as ImageIcon } from "lucide-react";

type Props = {
  shareTitle: string;
  shareText: string;
  shareUrl: string;
  imageBlobUrl?: string;
};

export default function SocialShareBar({ shareTitle, shareText, shareUrl, imageBlobUrl }: Props) {
  const canWebShare = typeof navigator !== "undefined" && !!(navigator as any).share;

  const share = async () => {
    try {
      const nav: any = navigator;
      if (canWebShare) {
        if (imageBlobUrl && nav.canShare?.({ files: [] })) {
          const res = await fetch(imageBlobUrl);
          const blob = await res.blob();
          const file = new File([blob], "vybe.jpg", { type: blob.type });
          await nav.share({ title: shareTitle, text: shareText, url: shareUrl, files: [file] });
        } else {
          await nav.share({ title: shareTitle, text: shareText, url: shareUrl });
        }
      } else {
        await navigator.clipboard.writeText(shareUrl);
        alert("Link copied! Paste it into your favourite app 📋");
      }
    } catch (e) {
      console.error(e);
    }
  };

  const urlEnc = encodeURIComponent(shareUrl);
  const textEnc = encodeURIComponent(`${shareTitle} — ${shareText}`);
  const wa = `https://wa.me/?text=${textEnc}%20${urlEnc}`;
  const x  = `https://twitter.com/intent/tweet?text=${textEnc}&url=${urlEnc}`;

  const open = (u: string) => window.open(u, "_blank");

  return (
    <div className="rounded-2xl border border-white/10 bg-black/20 p-3 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
      <div className="flex items-center gap-2">
        <ImageIcon className="w-4 h-4 text-white/70" />
        <span className="text-sm text-white/80">Share your Vybe pics</span>
      </div>
      <div className="flex items-center gap-2 flex-wrap">
        <button onClick={() => open(wa)} className="px-3 py-1.5 text-sm rounded-lg bg-white/10 hover:bg-white/15 transition">WhatsApp</button>
        <button onClick={() => open(x)}  className="px-3 py-1.5 text-sm rounded-lg bg-white/10 hover:bg-white/15 transition">X</button>
        <button onClick={share} className="px-3 py-1.5 text-sm rounded-lg bg-gradient-to-r from-red-500 to-pink-600 hover:from-red-600 hover:to-pink-700 text-white flex items-center gap-2 transition">
          <Share2 className="w-4 h-4" /> Share
        </button>
      </div>
    </div>
  );
}
